
import {Links} from '../routes/PathLink'

export const SideMenu = () => {

   let user_type = localStorage.getItem('user_type')
   console.log('side menu type', user_type)

   if(user_type === 'user'){
      //users/doctor menu
      const menu = [{
            label:'Dashboard',
            link:Links.MYDASHBOARD,
         },
         {
            label:'My Forums',
            link:Links.MYFORUMS,
         },
         {
            label:'My Screens',
            link:Links.MYSCREENS,
         },
         {
            label:'Most Active Stocks',
            link:'/most-active-stocks/today',
         },
          {
            label:'Top Gainers',
            link:'/top-gainers/today',
         },
         {
            label:'Top Losers',
            link:'/top-losers/today',
         },
         {
            label:'My Followed Screens',
            link:Links.MYFOLLOWEDSCREENS,
         },
         {
            label:'Profile',
            link:Links.PROFILE,
         },
        
      ]
      return menu
   }
   if(user_type === 'expert'){
      const menu = [
          {
            label:"My Dashboard",
            link:Links.DOCTORDASHBOARD,
         },
         {
            label:'Profile',
            link:Links.PROFILE_DOCTOR,
         },
        
        
        
      ]
      return menu
   }   
}